export default __webpack_public_path__ + "static/media/degrade.fc100df0.png";